import * as React from 'react'

import { AccessibleVideo, } from '../../../../../Shared/index'
import {
  BATS_CONNECT_ACTIVITY_VIDEO,
  GRAMMAR_ACTIVITY_WITH_SPANISH_TRANSLATION,
  LANGUAGE_SELECTION_PAGE
} from './asset_constants'
import SelectedTourIntroSlide from './shared_slides/selected_tour_intro_slide'
import FinalSlide from './shared_slides/final_slide'
import LearningToWriteSlide from './shared_slides/learning_to_write_slide'
import ActivitySummarySlide from './shared_slides/activity_summary_slide'
import GrowthDiagnosticSlide from './shared_slides/growth_diagnostic_slide'
import BeginWithADiagnosticSlide from './shared_slides/begin_with_a_diagnostic_slide'
import PersonalizedActivitySequencesSlide from './shared_slides/personalized_activity_sequences_slide'
import RecommendedPacksSlide from './shared_slides/recommended_packs_slide'
import ChooseTheProficiencyLevelSlide from './shared_slides/choose_the_proficiency_level_slide'
import OurAimSlide from './shared_slides/our_aim_slide'


const slideGroupClassName = 'english-learners-slide'

const selectedTourIntroSlide = (
  <SelectedTourIntroSlide
    firstItemCopy={<span>Discover our five <b>Learning to Write</b> tools to teach English Learners how to write strong, grammatically correct sentences.</span>}
    secondItemCopy={<span>Learn how to use a <b>Diagnostic</b> to pinpoint where ELL students need to improve.</span>}
    slideGroupClassName={slideGroupClassName}
  />
)

const learningToWriteSlide = (
  <LearningToWriteSlide
    slideGroupClassName={slideGroupClassName}
    subheaderCopy={<React.Fragment>Quill’s tools are specifically designed to help English learners <b>learn to write</b> strong, grammatically correct sentences.</React.Fragment>}
  />
)

const beginWithADiagnosticSlide = (
  <BeginWithADiagnosticSlide
    paragraphs={
      <React.Fragment>
        <p>Our ELL Diagnostics assess your students' knowledge of a variety of concepts specifically chosen for English language learners.</p>
        <p>There are six ELL diagnostics — Starter, Intermediate, and Advanced — each with a Baseline (Pre) and Growth (Post) version to track progress over time.</p>
      </React.Fragment>
    }
    slideGroupClassName={slideGroupClassName}
  />
)

const chooseTheProficiencyLevelSlide = (
  <ChooseTheProficiencyLevelSlide ell={true} slideGroupClassName={slideGroupClassName} />
)

const personalizedActivitySequencesSlide = (
  <PersonalizedActivitySequencesSlide slideGroupClassName={slideGroupClassName} />
)

const recommendedPacksSlide = (
  <RecommendedPacksSlide
    slideGroupClassName={slideGroupClassName}
    video={
      <AccessibleVideo
        ariaLabel="Animation of a user completing a sentence combining activity"
        src={BATS_CONNECT_ACTIVITY_VIDEO}
      />
    }
  />
)

const supportYourEnglishLearnersSlide = (
  <section className={`slide ${slideGroupClassName} support-your-english-learners-slide`} key="support-your-english-learners-slide">
    <h1>Support your English learners with translations in 16 languages</h1>
    <p>Directions, feedback, and hints are shown in both English and the student’s selected language to support understanding and reinforce English language development.</p>
    <div className="grid-wrapper">
      <img alt="Screenshot of the language selection page for Quill activities that support translations" src={LANGUAGE_SELECTION_PAGE} />
      <img
        alt="Screenshot of the student interface in a Quill Grammar activity, displaying translations into Spanish for the feedback and instructional hint"
        src={GRAMMAR_ACTIVITY_WITH_SPANISH_TRANSLATION}
      />
    </div>
  </section>
)

const activitySummarySlide = (
  <ActivitySummarySlide slideGroupClassName={slideGroupClassName} />
)

const growthDiagnosticSlide = (
  <GrowthDiagnosticSlide slideGroupClassName={slideGroupClassName} />
)

const ourAimSlide = (
  <OurAimSlide ell={true} slideGroupClassName={slideGroupClassName} />
)

const englishLearnersSlides = ({ getPremiumCredit, }) => [
  selectedTourIntroSlide,
  learningToWriteSlide,
  beginWithADiagnosticSlide,
  chooseTheProficiencyLevelSlide,
  personalizedActivitySequencesSlide,
  recommendedPacksSlide,
  supportYourEnglishLearnersSlide,
  activitySummarySlide,
  growthDiagnosticSlide,
  ourAimSlide,
  <FinalSlide getPremiumCredit={getPremiumCredit} key="final-slide" />,
]

export default englishLearnersSlides
